import { reserveParam } from '../hook/router';
import { ThemeModeEnum } from '../context/config';

export const applyThemeToURL = (theme: ThemeModeEnum) => {
    const html = document.getElementsByTagName('html')[0];
    if (html) {
        html.setAttribute('mode', theme);
        html.setAttribute('theme', theme);
    }
    reserveParam({ theme });
};
